module.exports = __webpack_public_path__ + "img/16.ec56593b.jpg";